import { Flex, Paper, Text } from '@mantine/core';
import {
  type CandidateStatusCode,
  useGetCandidateStatuses,
  useUpdateCandidateStatus,
} from '@entities/candidates';
import { showNotification } from '@shared/utils';
import { CandidateStatusSelect } from './CandidateStatusSelect';

type CandidateStatusBlockProps = {
  candidateId: number;
  status: CandidateStatusCode;
};

export const CandidateStatusBlock = ({
  candidateId,
  status,
}: CandidateStatusBlockProps) => {
  const { data: statuses, isLoading: isLoadingStatuses } =
    useGetCandidateStatuses();
  const { mutate: updateCandidateStatus, isPending } =
    useUpdateCandidateStatus(candidateId);

  const handleStatusChange = (nextStatus: CandidateStatusCode) => {
    updateCandidateStatus(
      {
        status: nextStatus,
      },
      {
        onError: error => {
          showNotification({
            error,
            variant: 'error',
            message:
              error.response?.data.message ||
              'Не удалось изменить статус кандидата',
          });
        },
      }
    );
  };

  return (
    <Paper p={24} bg='primary.0' radius={16}>
      <Flex direction='column' gap={16}>
        <Text size='lg' fw={600}>
          Статус
        </Text>

        <Flex gap={8} justify='space-between' align='center'>
          <CandidateStatusSelect
            status={status}
            statuses={statuses ?? []}
            onStatusChange={handleStatusChange}
            disabled={isPending || isLoadingStatuses}
          />
        </Flex>
      </Flex>
    </Paper>
  );
};
